import React from 'react'
import { Link } from 'react-router-dom'
import "../../Css/generator.css"
import EthIcon from "../../assets/ethereum.png"
import PolyIcon from "../../assets/polygon.png"
import BscIcon  from "../../assets/binance.png"
import Footer from '../Footer'
import Header from '../Header'
export default function Generator() {



    return (
        <>
          <Header/>
          <div  classname="work" style={{height:"78.2vh"}}>
            <section className='page-section hero mb-3' id="hero" >
                <div className='container text-start' >
                    <h1><span className='sub-highlight' style={{ borderBottom: "10px solid #808000" }}>Select your network</span></h1>
                    <p>
                        You're token will be deployed on the selected blockchain
                    </p>
                </div>
            </section>

            <div className='chain-select'>
                <div className='chain-item'>
                    <Link className='chain-link chain-ethereum' to="/createEthToken"
                    onClick = {()=>{
                          (localStorage.removeItem("walletAddr"));
                    }}
                    ><span className='title'>Ethereum</span><span className='logo'><img width={100} height={100} src={EthIcon} alt="ethicon"/></span><span className='text-muted'>Create your token on Ethereum</span></Link>

                </div>
                <div className='chain-item'>

                <Link className='chain-link chain-ethereum' to="/createPolyToken"
                onClick = {()=>{
                    (localStorage.removeItem("walletAddr"));
              }}
                ><span className='title'>Polygon</span><span className='logo'><img width={100} height={100} src={PolyIcon} alt="polyicon"/></span><span className='text-muted'>Create your token on Polygon</span></Link>
                </div>
                <div className='chain-item'>

                <Link className='chain-link chain-ethereum' to="/createbsctoken"
                onClick = {()=>{
                    (localStorage.removeItem("walletAddr"));
              }} 
                ><span className='title'>Binance Smart Chain</span><span className='logo'><img width={100} height={100} src={BscIcon} alt="bscicon"/></span><span className='text-muted'>Create your token on BSC</span></Link>
                </div>
                

            </div>
            </div>
            <Footer/>
        </>
    )
}
